import React from "react";

import {
  EmptyStateContainer,
  EmptyStateDescription,
  EmptyStateDetails,
  EmptyStateHeading,
} from "./styles";
import { useTheme } from "styled-components";
import { CUSTOM_EMPTY_STATE_TEMPLATE } from "./custom-templates";
import { useTranslation } from "react-i18next";

const translationPrefix = "custom-empty-state.";

function CustomEmptyState({ templateKey }) {
  const theme = useTheme();
  const { t } = useTranslation();

  const { title, description, imageUrl } = CUSTOM_EMPTY_STATE_TEMPLATE[
    templateKey
  ](theme.name);

  return (
    <EmptyStateContainer>
      <EmptyStateDetails>
        <img src={imageUrl} alt="Getting started" width={310} />
        <EmptyStateHeading>{t(translationPrefix + title)}</EmptyStateHeading>
        <EmptyStateDescription>
          {t(translationPrefix + description)}
        </EmptyStateDescription>
      </EmptyStateDetails>
    </EmptyStateContainer>
  );
}

export default CustomEmptyState;
